import * as prismic from '@prismicio/client';
import type { PrismicMatch } from './types';

// Het speelschema van donar.nl; de repo is publiek leesbaar
const client = prismic.createClient('donar');

const TIME_ZONE = 'Europe/Amsterdam';

/** Prismic-tijdstempels zijn UTC; de app werkt met Nederlandse datum en tijd */
function toLocalDateTime(date: Date) {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(date);
  const get = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find(p => p.type === type)?.value ?? '';

  return {
    date: `${get('year')}-${get('month')}-${get('day')}`,
    time: `${get('hour')}:${get('minute')}`,
  };
}

/** Thuiswedstrijden uit Prismic van vandaag en later, op volgorde */
export async function getUpcomingHomeMatches(): Promise<PrismicMatch[]> {
  const now = new Date();
  const today = toLocalDateTime(now).date;
  // Ruim genomen; wedstrijden van eerder vandaag vallen er hieronder weer af
  const since = new Date(now.getTime() - 24 * 60 * 60 * 1000);

  const documents = await client.getAllByType('match', {
    filters: [
      prismic.filter.at('my.match.is_home_game', true),
      prismic.filter.dateAfter('my.match.game_date', since),
    ],
    orderings: { field: 'my.match.game_date', direction: 'asc' },
  });

  return documents.flatMap(doc => {
    const gameDate = prismic.asDate(doc.data.game_date);
    if (!gameDate) return [];

    const { date, time } = toLocalDateTime(gameDate);
    if (date < today) return [];

    return [{
      prismic_id: doc.id,
      title: `Donar Groningen vs ${doc.data.opponent ?? ''}`.trim(),
      game_date: date,
      game_time: time,
    }];
  });
}
